module.exports = __webpack_public_path__ + "media/images/favicon-32x32-6df95a1238e0dfeb58631e01d73f2029.png";